var _g, _g2, _path, _g3, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 118.23,
    x: 3,
    y: 2,
    fill: "#F7F9FC",
    rx: 4.85
  }), /*#__PURE__*/React.createElement("rect", {
    width: 153.39,
    height: 117.62,
    x: 3.3,
    y: 2.3,
    stroke: "#DEE3EA",
    strokeWidth: 0.61,
    rx: 4.55
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0B0826",
    d: "M17.34 105.74H18c-.03-.86-.83-1.51-1.94-1.51-1.1 0-1.96.64-1.96 1.6 0 .77.56 1.23 1.46 1.49l.7.2c.6.17 1.14.38 1.14.95 0 .63-.6 1.04-1.4 1.04-.68 0-1.28-.3-1.34-.95h-.72c.07.94.83 1.58 2.06 1.58 1.32 0 2.08-.73 2.08-1.66 0-1.07-1.02-1.42-1.62-1.58l-.58-.15c-.42-.11-1.1-.34-1.1-.95 0-.55.5-.96 1.26-.96.7 0 1.22.33 1.29.9zm3.67 0h-.92v-1.03h-.66v1.03h-.65v.56h.65v2.69c0 .75.6 1.1 1.16 1.1.25 0 .4-.04.5-.07l-.14-.6c-.06.02-.14.04-.29.04-.29 0-.57-.1-.57-.65v-2.51h.92v-.56zm2.26 4.4c.75 0 1.14-.4 1.27-.68h.04v.58h.66v-2.83c0-1.37-1.04-1.53-1.6-1.53-.64 0-1.38.23-1.72 1.01l.63.23c.14-.32.49-.65 1.12-.65.6 0 .9.32.9.87v.02c0 .32-.32.3-1.1.4-.8.1-1.67.27-1.67 1.26 0 .84.65 1.32 1.47 1.32zm.1-.6c-.53 0-.91-.23-.91-.69 0-.5.46-.66.97-.72.28-.04 1.03-.12 1.15-.25v.6c0 .54-.43 1.07-1.21 1.07zm3.07.5h.66v-2.72c0-.58.46-1 1.09-1 .17 0 .36.03.4.04v-.68a5.98 5.98 0 00-.35 0c-.51 0-.96.28-1.12.7h-.04v-.64h-.64v4.3zm5.07-4.3h-.91v-1.03h-.66v1.03h-.65v.56h.65v2.69c0 .75.6 1.1 1.16 1.1.25 0 .4-.04.5-.07l-.14-.6c-.06.02-.15.04-.3.04-.28 0-.56-.1-.56-.65v-2.51h.91v-.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M141.04 106.28l-1.75-1.75.5-.5 2.26 2.25-2.26 2.26-.5-.5 1.75-1.76z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#DEE3EA",
    strokeWidth: 0.61,
    d: "M3.3 6.85A4.55 4.55 0 017.85 2.3h144.3a4.55 4.55 0 014.55 4.55v85.8H3.3V6.84z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#prefix__c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 22.01,
    r: 9.7,
    fill: "#0B0826"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M78.54 19.35a.32.32 0 100 .63.32.32 0 000-.63zm2.87 0a.32.32 0 100 .63.32.32 0 000-.63z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M83.3 24.5c0 .26-.2.47-.46.47h-5.75a.47.47 0 01-.47-.47v-2.7h6.68v2.71zm-3.33-6.47a3.35 3.35 0 013.31 2.94h-6.63a3.35 3.35 0 013.32-2.93zm4.15 2.93h-.01a4.17 4.17 0 00-1.9-3.08l.54-.68a.41.41 0 10-.64-.5l-.64.8a4.14 4.14 0 00-3 0l-.65-.8a.41.41 0 10-.64.5l.54.68a4.17 4.17 0 00-1.9 3.09h-.02v3.53c0 .71.58 1.3 1.3 1.3h5.74a1.29 1.29 0 001.28-1.3v-3.53zm-9.25.13a.41.41 0 00-.41.41v1.94a.41.41 0 00.82 0V21.5a.41.41 0 00-.41-.4zm3.24 5a.41.41 0 00-.4.4v.42a.41.41 0 10.81 0v-.41a.41.41 0 00-.4-.41zm3.49 0a.41.41 0 00-.41.4v.42a.41.41 0 10.82 0v-.41a.41.41 0 00-.41-.41zm3.5-5a.41.41 0 00-.42.41v1.94a.41.41 0 10.82 0V21.5a.41.41 0 00-.4-.4z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D193A",
    d: "M63.47 52.02l.52-1.61h2.54l.53 1.6h1.6l-2.44-7.05H64.3l-2.43 7.05h1.6zm.9-2.78l.87-2.67h.05l.87 2.67h-1.8zm6.58-.28c0-.69.4-1.09 1-1.09.59 0 .94.39.94 1.04V52h1.47v-3.37c0-1.23-.73-1.99-1.83-1.99-.78 0-1.35.4-1.6 1h-.05v-.93h-1.4v5.3h1.47v-3.06zm6.51 3.14c.86 0 1.3-.5 1.5-.93h.07V52h1.44v-7.05h-1.46v2.65h-.04c-.2-.43-.62-.95-1.51-.95-1.16 0-2.14.9-2.14 2.72 0 1.77.94 2.72 2.14 2.72zm.47-1.17c-.72 0-1.11-.64-1.11-1.56s.38-1.55 1.1-1.55c.72 0 1.12.6 1.12 1.55 0 .94-.4 1.56-1.11 1.56zm3.75 1.09h1.47v-3c0-.65.47-1.1 1.12-1.1.2 0 .48.04.62.08v-1.3a2.2 2.2 0 00-.46-.05c-.6 0-1.08.34-1.27 1h-.06v-.93h-1.42v5.3zm6.11.1c1.6 0 2.6-1.1 2.6-2.73 0-1.64-1-2.73-2.6-2.73s-2.6 1.09-2.6 2.73c0 1.63 1 2.73 2.6 2.73zm.01-1.14c-.74 0-1.12-.68-1.12-1.6s.38-1.6 1.12-1.6c.73 0 1.1.68 1.1 1.6s-.37 1.6-1.1 1.6zm3.55 1.04h1.47v-5.3h-1.47v5.3zm.74-5.98c.44 0 .8-.33.8-.74 0-.4-.36-.74-.8-.74-.43 0-.8.33-.8.74 0 .4.37.74.8.74zm3.86 6.06c.85 0 1.3-.5 1.5-.93h.06v.85h1.45v-7.06h-1.47v2.65h-.04c-.2-.43-.62-.95-1.5-.95-1.17 0-2.15.9-2.15 2.72 0 1.77.94 2.72 2.15 2.72zm.46-1.17c-.72 0-1.11-.64-1.11-1.56s.38-1.55 1.11-1.55c.71 0 1.11.6 1.11 1.55 0 .94-.4 1.56-1.11 1.56z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D193A",
    fillOpacity: 0.47,
    d: "M13.9 79.55h1.05l2.02-4v-.85h-3.4v.83h2.33v.04l-2 3.98zm9.8-2.43c0-1.59-.99-2.5-2.27-2.5-1.3 0-2.27.91-2.27 2.5 0 1.58.97 2.5 2.27 2.5.3 0 .59-.06.85-.16l.39.48h.96l-.7-.87c.48-.42.77-1.09.77-1.95zm-2.63.74l.62.82a1.36 1.36 0 01-.26.02c-.75 0-1.23-.55-1.23-1.58s.48-1.59 1.23-1.59c.74 0 1.23.56 1.23 1.59 0 .53-.13.93-.36 1.2l-.36-.46h-.87zm6.38-3.17v3.07c0 .55-.38.95-.98.95s-.99-.4-.99-.95v-3.07h-1.02v3.15c0 1.07.8 1.77 2 1.77 1.21 0 2.02-.7 2.02-1.77V74.7h-1.03zm1.87 4.85h3.28v-.84h-2.25v-1.16h2.08v-.84h-2.08v-1.16h2.24v-.85h-3.27v4.85zm6.72-3.45h.98c-.01-.87-.72-1.46-1.8-1.46-1.07 0-1.85.59-1.84 1.47 0 .71.5 1.12 1.32 1.32l.53.13c.53.13.82.28.82.6 0 .36-.34.6-.86.6-.53 0-.91-.24-.95-.73h-.99c.03 1.05.78 1.6 1.95 1.6 1.19 0 1.88-.57 1.89-1.46 0-.8-.61-1.24-1.46-1.43l-.43-.1c-.42-.1-.78-.25-.77-.6 0-.32.28-.55.78-.55.49 0 .79.23.83.6zm1.55-.55h1.49v4h1.01v-4h1.49v-.85h-3.99v.85zm5.67-.85h-1.03v4.85h1.03V74.7zm5.3 2.43c0-1.59-.99-2.5-2.27-2.5-1.3 0-2.27.91-2.27 2.5 0 1.58.97 2.5 2.27 2.5 1.28 0 2.27-.91 2.27-2.5zm-1.04 0c0 1.03-.49 1.58-1.23 1.58-.75 0-1.23-.55-1.23-1.58s.48-1.59 1.23-1.59c.74 0 1.23.56 1.23 1.59zm5.85-2.43h-1.01v3.05h-.05l-2.1-3.05h-.9v4.85h1.03V76.5h.04l2.1 3.05h.9V74.7zm3.48 1.4h.99c-.02-.87-.73-1.46-1.8-1.46s-1.85.59-1.85 1.47c0 .71.5 1.12 1.33 1.32l.52.13c.53.13.83.28.83.6 0 .36-.34.6-.86.6-.54 0-.92-.24-.95-.73h-1c.03 1.05.78 1.6 1.96 1.6s1.88-.57 1.88-1.46c0-.8-.6-1.24-1.45-1.43l-.44-.1c-.42-.1-.77-.25-.76-.6 0-.32.27-.55.77-.55s.8.23.83.6zm66.35-1.39h-.96l-1.2.75v.91l1.11-.7h.03v3.89h1.03V74.7zm3.06 4.95c1.22 0 1.96-.93 1.96-2.53 0-1.58-.75-2.5-1.96-2.5-1.22 0-1.96.91-1.96 2.5 0 1.6.74 2.53 1.96 2.53zm0-.85c-.56 0-.92-.56-.92-1.68 0-1.1.36-1.65.92-1.65.55 0 .91.55.91 1.65 0 1.12-.36 1.68-.91 1.68zm4.26-4.1v4.84h1v-3.16h.04l1.25 3.14h.68l1.25-3.13h.04v3.15h1V74.7h-1.27l-1.33 3.26h-.06l-1.33-3.26h-1.27zm7.13 0h-1.03v4.84h1.03V74.7zm4.9 0h-1.02v3.04h-.04l-2.1-3.05h-.9v4.85h1.03V76.5h.03l2.11 3.05h.89V74.7z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "prefix__a",
    width: 158.85,
    height: 123.08,
    x: 0.57,
    y: 0.79,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1.21,
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.61
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.968627 0 0 0 0 0.976471 0 0 0 0 0.988235 0 0 0 0.69575 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "prefix__c",
    width: 20.61,
    height: 21.22,
    x: 69.69,
    y: 12.31,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0431373 0 0 0 0 0.0313726 0 0 0 0 0.14902 0 0 0 0.111943 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h131.57v8.49H0z",
    transform: "translate(13.3 102.04)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.02709aab.svg";
export { ForwardRef as ReactComponent };